import React from "react";
import {Box} from "@chakra-ui/react";

interface SvgProps {
    w?: string;
    h?: string;
    strokeColor?: string;
}

function ImageIcon({w = "24px", h = "24px", strokeColor = "#FFFFFF"}: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M14.264 15.938l-1.668-1.655c-.805-.798-1.208-1.197-1.67-1.343a2 2 0 00-1.246.014c-.458.155-.852.563-1.64 1.379L4.045 18.28m10.22-2.343l.341-.338c.806-.8 1.21-1.199 1.671-1.345a2 2 0 011.248.015c.458.156.852.565 1.64 1.382l.836.842m-5.736-.555l4.011 4.018m0 0c-.357.044-.82.044-1.475.044H7.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874 1.845 1.845 0 01-.174-.628m14.231 1.676a1.85 1.85 0 00.633-.174 2 2 0 00.874-.874C20 18.48 20 17.92 20 16.8v-.307M4.044 18.28C4 17.922 4 17.457 4 16.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C5.52 4 6.08 4 7.2 4h9.6c1.12 0 1.68 0 2.108.218a2 2 0 01.874.874C20 5.52 20 6.08 20 7.2v9.293M17 9a2 2 0 11-4 0 2 2 0 014 0z"
            ></path>
        </svg>
    );
}

const HomeComponent = ({w = "22px", h = "21px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
    >
        <path
            fill={strokeColor}
            d="m12 3.228 6 5.4V18h-2.4v-7.2H8.4V18H6V8.628l6-5.4ZM12 0 0 10.8h3.6v9.6h7.2v-7.2h2.4v7.2h7.2v-9.6H24L12 0Z"
        />
    </svg>
)

const CategoryIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        fill={strokeColor}
        width={w}
        height={h}
        viewBox="0 0 35 35"
        data-name="Layer 2"
        id="e73e2821-510d-456e-b3bd-9363037e93e3"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.933,15.055H3.479A3.232,3.232,0,0,1,.25,11.827V3.478A3.232,3.232,0,0,1,3.479.25h8.454a3.232,3.232,0,0,1,3.228,3.228v8.349A3.232,3.232,0,0,1,11.933,15.055ZM3.479,2.75a.73.73,0,0,0-.729.728v8.349a.73.73,0,0,0,.729.728h8.454a.729.729,0,0,0,.728-.728V3.478a.729.729,0,0,0-.728-.728Z"/>
        <path
            d="M11.974,34.75H3.52A3.233,3.233,0,0,1,.291,31.521V23.173A3.232,3.232,0,0,1,3.52,19.945h8.454A3.232,3.232,0,0,1,15.2,23.173v8.348A3.232,3.232,0,0,1,11.974,34.75ZM3.52,22.445a.73.73,0,0,0-.729.728v8.348a.73.73,0,0,0,.729.729h8.454a.73.73,0,0,0,.728-.729V23.173a.729.729,0,0,0-.728-.728Z"/>
        <path
            d="M31.522,34.75H23.068a3.233,3.233,0,0,1-3.229-3.229V23.173a3.232,3.232,0,0,1,3.229-3.228h8.454a3.232,3.232,0,0,1,3.228,3.228v8.348A3.232,3.232,0,0,1,31.522,34.75Zm-8.454-12.3a.73.73,0,0,0-.729.728v8.348a.73.73,0,0,0,.729.729h8.454a.73.73,0,0,0,.728-.729V23.173a.729.729,0,0,0-.728-.728Z"/>
        <path
            d="M27.3,15.055a7.4,7.4,0,1,1,7.455-7.4A7.437,7.437,0,0,1,27.3,15.055Zm0-12.3a4.9,4.9,0,1,0,4.955,4.9A4.935,4.935,0,0,0,27.3,2.75Z"/>
    </svg>
);

const ProductIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
    >
        <g clipPath="url(#a)">
            <path stroke={strokeColor} strokeWidth={2} d="M3 2h3v11c0 .667.4 2 2 2h14"/>
            <path
                stroke={strokeColor}
                strokeWidth={2}
                d="M10 6.5V2h7.5v4.5m-7.5 0v5h10v-5h-2.5m-7.5 0h7.5"
            />
            <path
                fill={strokeColor}
                fillRule="evenodd"
                d="M8.5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-1.3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM19.5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-1.3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z"/>
            </clipPath>
        </defs>
    </svg>
)

const MediaIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
        viewBox="0 0 22 19"
    >
        <path
            fill="#000"
            d="M6 15c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 014 13V2c0-.55.196-1.021.588-1.413A1.925 1.925 0 016 0h4.175a1.978 1.978 0 011.4.575L13 2h7c.55 0 1.021.196 1.413.588.391.391.587.862.587 1.412v9c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0120 15H6zm0-2h14V4h-7.825l-2-2H6v11zm-4 6c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 010 17V5c0-.283.096-.521.288-.713A.967.967 0 011 4a.97.97 0 01.713.287A.97.97 0 012 5v12h16c.283 0 .52.096.712.288A.965.965 0 0119 18c0 .283-.096.52-.288.712A.965.965 0 0118 19H2zm7-8h8c.2 0 .35-.092.45-.275a.44.44 0 00-.05-.525l-2.375-3.175a.475.475 0 00-.4-.2c-.167 0-.3.067-.4.2L12 10l-1.225-1.65a.475.475 0 00-.4-.2c-.167 0-.3.067-.4.2L8.6 10.2a.44.44 0 00-.05.525c.1.183.25.275.45.275z"
        ></path>
    </svg>
);

const EventIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
    >
        <g clipPath="url(#a)">
            <path
                stroke={strokeColor}
                strokeWidth={2}
                d="M4 9h16v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9Z"
            />
            <mask id="b" fill={strokeColor}>
                <path
                    fillRule="evenodd"
                    d="M16 3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v4H3V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 2 0v1h8V3Zm3 3H5v2h14V6Z"
                    clipRule="evenodd"
                />
            </mask>
            <path
                fill={strokeColor}
                fillRule="evenodd"
                d="M16 3a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v4H3V6a2 2 0 0 1 2-2h1V3a1 1 0 0 1 2 0v1h8V3Zm3 3H5v2h14V6Z"
                clipRule="evenodd"
            />
            <path
                fill={strokeColor}
                d="M18 4h-2v2h2V4Zm3 6v2h2v-2h-2ZM3 10H1v2h2v-2Zm3-6v2h2V4H6Zm2 0H6v2h2V4Zm8 0v2h2V4h-2ZM5 6V4H3v2h2Zm14 0h2V4h-2v2ZM5 8H3v2h2V8Zm14 0v2h2V8h-2Zm-2-8a3 3 0 0 0-3 3h4a1 1 0 0 1-1 1V0Zm3 3a3 3 0 0 0-3-3v4a1 1 0 0 1-1-1h4Zm0 1V3h-4v1h4Zm-1-2h-1v4h1V2Zm4 4a4 4 0 0 0-4-4v4h4Zm0 2V6h-4v2h4Zm0 2V8h-4v2h4Zm-4 2h2V8h-2v4ZM5 12h14V8H5v4Zm-2 0h2V8H3v4ZM1 8v2h4V8H1Zm0-2v2h4V6H1Zm4-4a4 4 0 0 0-4 4h4V2Zm1 0H5v4h1V2Zm2 2V3H4v1h4Zm0-1a1 1 0 0 1-1 1V0a3 3 0 0 0-3 3h4ZM7 4a1 1 0 0 1-1-1h4a3 3 0 0 0-3-3v4ZM6 3v1h4V3H6Zm10-1H8v4h8V2Zm-2 1v1h4V3h-4ZM5 8h14V4H5v4Zm2 0V6H3v2h4Zm12-2H5v4h14V6Zm-2 0v2h4V6h-4Z"
                mask="url(#b)"
            />
            <path
                stroke={strokeColor}
                strokeWidth={2}
                d="M10 19v-6.736a.5.5 0 0 0-.865-.342L7 14.2"
            />
            <rect
                width={4}
                height={6}
                x={13}
                y={12}
                stroke={strokeColor}
                strokeWidth={2}
                rx={2}
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill={strokeColor} d="M0 0h24v24H0z"/>
            </clipPath>
        </defs>
    </svg>
);

const NewsIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
    >
        <path
            fill={strokeColor}
            d="M2 3v15c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3V7h-2v11c0 .565-.435 1-1 1s-1-.435-1-1V3H2Zm2 2h12v13c0 .388.279.658.416 1H5c-.565 0-1-.435-1-1V5Zm2 2v3h8V7H6Zm0 5v2h8v-2H6Zm0 4v2h8v-2H6Z"
        />
    </svg>
)

const ProfileIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none">
        <g stroke={strokeColor} strokeWidth={2} clipPath="url(#a)">
            <path
                d="M19 20H4.5a.5.5 0 0 1-.5-.5v-2.293c0-.133.055-.263.15-.355 6.636-6.488 12.833-2.787 15.236.012a.48.48 0 0 1 .114.315V19.5a.5.5 0 0 1-.5.5Z"/>
            <circle cx={11.5} cy={8.5} r={3.5}/>
        </g>
        <defs>
            <clipPath id="a">
                <path fill={strokeColor} d="M0 0h24v24H0z"/>
            </clipPath>
        </defs>
    </svg>
)

const ExitIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
    >
        <g clipPath="url(#a)">
            <path
                fill={strokeColor}
                d="M10.09 16.59 11.5 18l5-5-5-5-1.41 1.41L12.67 12H3v2h9.67l-2.58 2.59ZM19 4H5a2 2 0 0 0-2 2v4h2V6h14v14H5v-4H3v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill={strokeColor} d="M0 0h24v24H0z"/>
            </clipPath>
        </defs>
    </svg>
)

const EyeIcon = ({w = "18px", h = "18px", strokeColor = "#000000"}: SvgProps) => {
    return (
        <svg
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 21 15"
        >
            <path
                fill={strokeColor}
                d="M10.268 1.955c2.373 0 4.583.831 6.302 2.274 1.915 1.61 1.916 4.592.001 6.202a9.756 9.756 0 01-6.303 2.274 9.756 9.756 0 01-6.303-2.274c-1.915-1.61-1.914-4.593.001-6.202a9.765 9.765 0 016.302-2.274zm0-1.955C6.466 0 3.09 1.79.951 4.563a4.54 4.54 0 000 5.533 11.736 11.736 0 009.317 4.563c3.802 0 7.178-1.79 9.317-4.563a4.54 4.54 0 000-5.533A11.737 11.737 0 0010.268 0zm0 4.886c1.367 0 2.477 1.095 2.477 2.444 0 1.348-1.11 2.443-2.477 2.443-1.367 0-2.477-1.095-2.477-2.443 0-1.35 1.11-2.444 2.477-2.444zm0-1.954c-2.457 0-4.458 1.974-4.458 4.398 0 2.423 2.001 4.397 4.458 4.397 2.457 0 4.458-1.974 4.458-4.397 0-2.424-2.001-4.398-4.458-4.398z"
            ></path>
        </svg>
    );
}

const EditIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => {
    return (
        <svg
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 19 18"
        >
            <path
                fill={strokeColor}
                d="M11.431 6.02l.92.92L3.291 16h-.92v-.92l9.06-9.06zm3.6-6.02c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41L15.741.29c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L.371 14.25V18h3.75l11.06-11.06-3.75-3.75z"
            ></path>
        </svg>
    );
}

const DeleteIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 15 18"
        >
            <path
                fill={strokeColor}
                d="M11.371 6v10h-8V6h8zm-1.5-6h-5l-1 1h-3.5v2h14V1h-3.5l-1-1zm3.5 4h-12v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4z"
            ></path>
        </svg>
    );
}

function AddIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            fill="none"
            viewBox="0 0 48 48"
        >
            <g clipPath="url(#clip0_365_551)">
                <path
                    fill="#C1E9FB"
                    d="M38 26H26v12h-4V26H10v-4h12V10h4v12h12v4z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_365_551">
                    <path fill="#fff" d="M0 0H48V48H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

const LinkIcon = ({w = "24px", h = "24px", strokeColor = "#000000"}: SvgProps) => (
    <svg
        width={w}
        height={h}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <rect width={16} height={16} id="icon-bound" fill="none"/>
        <path
            d="M6.794,12.794C6.316,13.269,5.681,13.531,5,13.531s-1.316-0.262-1.794-0.738c-0.987-0.988-0.987-2.597,0-3.584L5.5,6.916 L4.084,5.5L1.791,7.794c-1.766,1.769-1.766,4.644,0.003,6.413C2.647,15.062,3.784,15.531,5,15.531s2.353-0.469,3.206-1.325 l2.294-2.294L9.084,10.5L6.794,12.794z M14.206,1.794C13.353,0.938,12.216,0.469,11,0.469S8.647,0.938,7.794,1.794L5.5,4.084 L6.916,5.5l2.294-2.294C9.684,2.731,10.319,2.469,11,2.469s1.316,0.263,1.794,0.737c0.988,0.987,0.988,2.597,0,3.584L10.5,9.084 l1.416,1.416l2.294-2.294C15.975,6.438,15.975,3.562,14.206,1.794z M11.706,5.706l-1.416-1.416l-6,6l1.416,1.416L11.706,5.706z"/>
    </svg>
);

const TaxIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width={"24px"}
        height={"24px"}
        viewBox="0 0 512 512"
        xmlSpace="preserve"
    >
        <g>
            <g>
                <path
                    d="M427.023,0H84.977C71.126,0,59.858,11.268,59.858,25.119v461.762c0,13.851,11.268,25.119,25.119,25.119h265.086 c2.126,0,4.166-0.844,5.668-2.348l94.063-94.063c1.504-1.503,2.348-3.542,2.348-5.668V25.119C452.142,11.268,440.874,0,427.023,0z  M358.079,484.63v-57.607c0-5.01,4.076-9.086,9.086-9.086h57.607L358.079,484.63z M436.109,401.904h-68.944 c-13.851,0-25.119,11.268-25.119,25.119v68.944H84.977c-5.01,0-9.086-4.076-9.086-9.086V25.119c0-5.01,4.076-9.086,9.086-9.086 h342.046c5.01,0,9.086,4.076,9.086,9.086V401.904z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M204.693,68.409h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h26.188v77.495 c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017V84.443h26.188c4.427,0,8.017-3.589,8.017-8.017 S209.12,68.409,204.693,68.409z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M289.332,159.634l-23.826-79.418c-2.119-7.062-8.496-11.807-15.869-11.807h-4.378c-7.373,0-13.75,4.745-15.869,11.807 l-23.826,79.418c-1.272,4.241,1.134,8.71,5.375,9.982c4.241,1.275,8.71-1.134,9.982-5.374l3.416-11.39h46.219l3.417,11.389 c1.042,3.473,4.227,5.715,7.676,5.715c0.762,0,1.538-0.11,2.307-0.34C288.198,168.344,290.605,163.875,289.332,159.634z  M229.149,136.818l15.598-51.995c0.067-0.224,0.278-0.381,0.512-0.381h4.378c0.234,0,0.445,0.156,0.512,0.381l15.598,51.995 H229.149z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M373.732,157.34l-26.712-38.158l26.712-38.158c2.539-3.627,1.657-8.626-1.97-11.165c-3.627-2.539-8.626-1.658-11.165,1.97 l-23.362,33.374l-23.362-33.374c-2.539-3.628-7.539-4.51-11.165-1.97c-3.628,2.539-4.51,7.538-1.97,11.165l26.712,38.158 L300.74,157.34c-2.539,3.627-1.657,8.626,1.97,11.165c1.399,0.98,3.003,1.449,4.59,1.449c2.527,0,5.015-1.192,6.574-3.42 l23.362-33.374l23.362,33.374c1.56,2.228,4.047,3.42,6.574,3.42c1.587,0,3.192-0.47,4.59-1.449 C375.389,165.966,376.272,160.967,373.732,157.34z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M136.284,213.779h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,213.779,136.284,213.779z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M136.284,247.983h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,247.983,136.284,247.983z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M136.284,282.188h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,282.188,136.284,282.188z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M392.818,213.779h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,213.779,392.818,213.779z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M392.818,247.983h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,247.983,392.818,247.983z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M392.818,282.188h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,282.188,392.818,282.188z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M273.102,213.779H170.489c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614 c4.427,0,8.017-3.589,8.017-8.017S277.53,213.779,273.102,213.779z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M238.898,247.983h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h68.409 c4.427,0,8.017-3.589,8.017-8.017S243.325,247.983,238.898,247.983z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M273.102,282.188H170.489c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614 c4.427,0,8.017-3.589,8.017-8.017S277.53,282.188,273.102,282.188z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M152.852,387.18v-27.859c5.907,1.936,9.62,5.833,9.62,9.447c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017 c0-12.784-10.768-23.198-25.653-25.984v-1.273c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017v1.273 c-14.885,2.786-25.653,13.2-25.653,25.984c0,17.862,14.265,25.369,25.653,29.69v27.859c-5.907-1.936-9.62-5.834-9.62-9.447 c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017c0,12.784,10.768,23.198,25.653,25.984v1.273 c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-1.273c14.885-2.786,25.653-13.2,25.653-25.984 C178.505,399.007,164.24,391.5,152.852,387.18z M136.818,380.966c-7.992-3.916-9.62-7.337-9.62-12.198 c0-3.614,3.713-7.511,9.62-9.447V380.966z M152.852,426.315V404.67c7.992,3.916,9.62,7.337,9.62,12.198 C162.472,420.482,158.758,424.38,152.852,426.315z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M264.551,350.597h-59.858c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h59.858 c4.427,0,8.017-3.589,8.017-8.017S268.979,350.597,264.551,350.597z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M238.898,419.006h-34.205c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017C246.914,422.596,243.325,419.006,238.898,419.006z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M290.205,419.006h-17.102c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017C298.221,422.596,294.632,419.006,290.205,419.006z"/>
            </g>
        </g>
        <g>
            <g>
                <path
                    d="M315.858,384.802H204.693c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h111.165 c4.427,0,8.017-3.589,8.017-8.017C323.875,388.391,320.285,384.802,315.858,384.802z"/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={273.102} cy={256} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={307.307} cy={256} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={341.511} cy={256} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={307.307} cy={221.795} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={341.511} cy={221.795} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={307.307} cy={290.205} r={8.017}/>
            </g>
        </g>
        <g>
            <g>
                <circle cx={341.511} cy={290.205} r={8.017}/>
            </g>
        </g>
    </svg>
);

const LocationIcon = () => (
    <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 2c-4.4 0-8 3.6-8 8 0 5.4 7 11.5 7.3 11.8.2.1.5.2.7.2.2 0 .5-.1.7-.2.3-.3 7.3-6.4 7.3-11.8 0-4.4-3.6-8-8-8zm0 17.7c-2.1-2-6-6.3-6-9.7 0-3.3 2.7-6 6-6s6 2.7 6 6-3.9 7.7-6 9.7zM12 6c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
            fill="#0D0D0D"
        />
    </svg>
);

const ProducerIcon = ({w = "20", h = "18", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
        viewBox="0 0 20 18"
    >
        <path
            fill="#000"
            fillRule="evenodd"
            d="M18 0H2v6h16V0zm-2 2H4v2h12V2z"
            clipRule="evenodd"
        ></path>
        <path
            stroke="#000"
            strokeWidth="2"
            d="M1 8l2-3.5h14L19 8v1H1V8zM2 15.5V9h16v7c0 .8-.667 1-1 1H3.5C2.3 17 2 16 2 15.5z"
        ></path>
        <path stroke="#000" strokeWidth="2" d="M6 13V9h4v4H6zM14 9v8"></path>
    </svg>
);

const PersonIcon = ({w = "24", h = "24", strokeColor = "#000000"}: SvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        fill="none"
        viewBox="0 0 24 24"
    >
        <g clipPath="url(#clip0_1027_5)">
            <path
                fill="#000"
                d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_1027_5">
                <path fill="#fff" d="M0 0H24V24H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

function FileIcon({w = "64", h = "80", strokeColor = "#000"}: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 64 80"
        >
            <path
                fill={strokeColor}
                d="M8 0C3.6 0 .04 3.6.04 8L0 72c0 4.4 3.56 8 7.96 8H56c4.4 0 8-3.6 8-8V24L40 0H8zm28 28V6l22 22H36z"
            ></path>
        </svg>
    );
}

function QrIcon({w = "72", h = "72", strokeColor = "#000"}: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            fill="none"
            viewBox="0 0 72 72"
        >
            <path
                d="M0 32h32V0H0v32zM8 8h16v16H8V8zM0 72h32V40H0v32zm8-24h16v16H8V48zM40 0v32h32V0H40zm24 24H48V8h16v16zM72 64h-8v8h8v-8zM48 40h-8v8h8v-8zM56 48h-8v8h8v-8zM48 56h-8v8h8v-8zM56 64h-8v8h8v-8zM64 56h-8v8h8v-8zM64 40h-8v8h8v-8zM72 48h-8v8h8v-8z"
                fill={strokeColor}
            />
        </svg>
    );
}

function SmartVenuesLogo({strokeColor}: SvgProps) {
    return (
        <svg width={'100%'} height={36} viewBox="0 0 401 36" fill="none">
            <path
                d="M16.432 35.48c-3.072 0-5.968-.528-8.688-1.584C5.056 32.84 2.8 31.368.976 29.48c-.416-.384-.624-.848-.624-1.392 0-.672.288-1.264.864-1.776.416-.416.88-.624 1.392-.624.672 0 1.36.336 2.064 1.008 1.44 1.408 3.168 2.496 5.184 3.264 2.048.736 4.24 1.104 6.576 1.104 2.368 0 4.192-.416 5.472-1.248 1.312-.832 1.968-2 1.968-3.504 0-1.472-.672-2.656-2.016-3.552-1.344-.928-3.632-1.744-6.864-2.448-4.768-1.024-8.224-2.368-10.368-4.032-2.144-1.696-3.216-3.872-3.216-6.528 0-1.728.544-3.264 1.632-4.608C4.16 3.8 5.712 2.76 7.696 2.024 9.712 1.288 12.032.92 14.656.92c2.944 0 5.584.496 7.92 1.488 2.368.992 4.112 2.368 5.232 4.128.32.512.48 1.008.48 1.488 0 .704-.352 1.296-1.056 1.776-.416.256-.832.384-1.248.384-.384 0-.768-.096-1.152-.288a2.834 2.834 0 01-.96-.768c-.928-1.216-2.208-2.144-3.84-2.784-1.6-.672-3.392-1.008-5.376-1.008-2.496 0-4.416.384-5.76 1.152-1.312.736-1.968 1.824-1.968 3.264 0 1.344.64 2.448 1.92 3.312 1.28.832 3.536 1.616 6.768 2.352 4.896 1.152 8.416 2.576 10.56 4.272 2.144 1.696 3.216 3.904 3.216 6.624 0 1.824-.544 3.44-1.632 4.848-1.056 1.376-2.56 2.448-4.512 3.216-1.952.736-4.224 1.104-6.816 1.104zm22.95 0c-.832 0-1.504-.224-2.016-.672-.48-.448-.72-1.072-.72-1.872V12.488c0-3.616 1.024-6.448 3.072-8.496C41.798 1.944 44.63.92 48.214.92c1.824 0 3.536.464 5.136 1.392 1.632.928 2.96 2.208 3.984 3.84 1.024-1.664 2.336-2.944 3.936-3.84C62.87 1.384 64.63.92 66.55.92c3.616 0 6.432 1.024 8.448 3.072 2.048 2.048 3.072 4.88 3.072 8.496v20.448c0 .768-.256 1.392-.768 1.872-.48.448-1.136.672-1.968.672-.832 0-1.504-.224-2.016-.672-.48-.448-.72-1.072-.72-1.872V12.488c0-2.464-.496-4.272-1.488-5.424-.96-1.152-2.544-1.728-4.752-1.728-2.016 0-3.568.624-4.656 1.872-1.088 1.248-1.632 3.008-1.632 5.28v20.448c0 .8-.256 1.424-.768 1.872-.48.448-1.136.672-1.968.672-.832 0-1.488-.224-1.968-.672-.448-.448-.672-1.072-.672-1.872V12.488c0-2.24-.56-3.984-1.68-5.232-1.12-1.28-2.656-1.92-4.608-1.92-2.24 0-3.856.576-4.848 1.728-.96 1.152-1.44 2.96-1.44 5.424v20.448c0 .768-.256 1.392-.768 1.872-.48.448-1.136.672-1.968.672zm49.119-.048c-.832 0-1.488-.224-1.968-.672-.48-.448-.72-1.072-.72-1.872V15.416c0-4.544 1.296-8.096 3.888-10.656C92.293 2.2 95.893.92 100.5.92c3.008 0 5.616.592 7.824 1.776 2.208 1.152 3.888 2.816 5.04 4.992 1.184 2.176 1.776 4.752 1.776 7.728v17.472c0 .8-.24 1.424-.72 1.872-.48.448-1.136.672-1.968.672-.832 0-1.504-.224-2.016-.672-.512-.48-.768-1.104-.768-1.872v-8.832H91.285v8.832c0 .768-.256 1.392-.768 1.872-.512.448-1.184.672-2.016.672zm21.168-15.648v-4.512c0-3.264-.784-5.744-2.352-7.44-1.536-1.696-3.808-2.544-6.816-2.544-3.04 0-5.344.848-6.912 2.544-1.536 1.664-2.304 4.144-2.304 7.44v4.512h18.384zM122.893 8.12c0-2.08.608-3.712 1.824-4.896 1.216-1.216 2.928-1.824 5.136-1.824h8.688c4.64 0 8.128.928 10.464 2.784 2.368 1.856 3.552 4.592 3.552 8.208 0 3.424-1.04 6.08-3.12 7.968s-4.96 2.832-8.64 2.832l7.968 8.064c.512.512.768 1.072.768 1.68 0 .672-.32 1.28-.96 1.824-.608.448-1.2.672-1.776.672-.8 0-1.568-.384-2.304-1.152l-10.56-10.944h-5.424v9.552c0 .8-.272 1.44-.816 1.92-.512.448-1.184.672-2.016.672-.864 0-1.552-.224-2.064-.672-.48-.48-.72-1.12-.72-1.92V8.12zm15.6 10.8c3.072 0 5.232-.48 6.48-1.44 1.28-.992 1.92-2.688 1.92-5.088 0-2.336-.688-4.016-2.064-5.04-1.376-1.024-3.488-1.536-6.336-1.536h-7.824c-.672 0-1.2.224-1.584.672-.384.416-.576 1.008-.576 1.776V18.92h9.984zm34.36 16.56c-.832 0-1.504-.224-2.016-.672-.48-.448-.72-1.072-.72-1.872V5.672h-9.84c-.832 0-1.472-.176-1.92-.528-.448-.384-.672-.912-.672-1.584 0-.704.224-1.232.672-1.584.448-.384 1.088-.576 1.92-.576h25.152c.832 0 1.472.192 1.92.576.48.352.72.88.72 1.584 0 .672-.24 1.2-.72 1.584-.448.352-1.088.528-1.92.528h-9.84v27.264c0 .768-.256 1.392-.768 1.872-.48.448-1.136.672-1.968.672zm36.878 0c-2.144 0-3.904-.768-5.28-2.304-1.376-1.568-2.608-4.096-3.696-7.584l-6.72-21.744c-.128-.512-.192-.864-.192-1.056 0-1.248.848-1.872 2.544-1.872.864 0 1.504.176 1.92.528.448.32.8.88 1.056 1.68l6.72 22.032c.64 2.176 1.232 3.728 1.776 4.656.576.896 1.2 1.344 1.872 1.344.64 0 1.232-.448 1.776-1.344.576-.928 1.2-2.48 1.872-4.656l6.672-22.032c.256-.8.592-1.36 1.008-1.68.448-.352 1.104-.528 1.968-.528 1.696 0 2.544.608 2.544 1.824 0 .352-.064.72-.192 1.104l-6.72 21.744c-1.12 3.552-2.368 6.096-3.744 7.632-1.344 1.504-3.072 2.256-5.184 2.256zm30.374-.48c-2.272 0-4.048-.592-5.328-1.776-1.248-1.216-1.872-2.896-1.872-5.04V8.072c0-2.08.608-3.712 1.824-4.896 1.216-1.184 2.912-1.776 5.088-1.776h14.928c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-14.16c-.704 0-1.248.224-1.632.672-.384.448-.576 1.056-.576 1.824v7.536h12.72c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-12.72v8.256c0 .768.192 1.376.576 1.824.384.448.928.672 1.632.672h15.216c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-15.696zm28.058.48c-.832 0-1.488-.224-1.968-.672-.48-.448-.72-1.072-.72-1.872V14.312c0-4.192 1.296-7.472 3.888-9.84 2.624-2.368 6.224-3.552 10.8-3.552 3.008 0 5.616.544 7.824 1.632 2.208 1.056 3.888 2.592 5.04 4.608 1.184 2.016 1.776 4.4 1.776 7.152v18.624c0 .8-.24 1.424-.72 1.872-.48.448-1.136.672-1.968.672-.832 0-1.504-.224-2.016-.672-.48-.48-.72-1.104-.72-1.872V14.168c0-2.848-.8-5.04-2.4-6.576-1.6-1.536-3.872-2.304-6.816-2.304s-5.232.784-6.864 2.352c-1.6 1.536-2.4 3.712-2.4 6.528v18.768c0 .768-.256 1.392-.768 1.872-.48.448-1.136.672-1.968.672zm48.793 0c-2.944 0-5.52-.592-7.728-1.776a12.19 12.19 0 01-5.088-5.088c-1.184-2.208-1.776-4.816-1.776-7.824V3.464c0-.8.24-1.424.72-1.872.48-.448 1.136-.672 1.968-.672.832 0 1.488.24 1.968.72.512.448.768 1.056.768 1.824v17.472c0 3.264.8 5.776 2.4 7.536 1.632 1.76 3.936 2.64 6.912 2.64s5.28-.88 6.912-2.64c1.632-1.792 2.448-4.304 2.448-7.536V3.464c0-.768.24-1.376.72-1.824.512-.48 1.184-.72 2.016-.72.832 0 1.488.224 1.968.672.512.448.768 1.072.768 1.872v17.328c0 2.912-.624 5.488-1.872 7.728-1.216 2.208-2.96 3.92-5.232 5.136-2.24 1.216-4.864 1.824-7.872 1.824zm30.018-.48c-2.272 0-4.048-.592-5.328-1.776-1.248-1.216-1.872-2.896-1.872-5.04V8.072c0-2.08.608-3.712 1.824-4.896 1.216-1.184 2.912-1.776 5.088-1.776h14.928c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-14.16c-.704 0-1.248.224-1.632.672-.384.448-.576 1.056-.576 1.824v7.536h12.72c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-12.72v8.256c0 .768.192 1.376.576 1.824.384.448.928.672 1.632.672h15.216c.832 0 1.472.192 1.92.576.448.352.672.88.672 1.584 0 .672-.224 1.2-.672 1.584-.448.352-1.088.528-1.92.528h-15.696zm40.971.48c-3.072 0-5.968-.528-8.688-1.584-2.688-1.056-4.944-2.528-6.768-4.416-.416-.384-.624-.848-.624-1.392 0-.672.288-1.264.864-1.776.416-.416.88-.624 1.392-.624.672 0 1.36.336 2.064 1.008 1.44 1.408 3.168 2.496 5.184 3.264 2.048.736 4.24 1.104 6.576 1.104 2.368 0 4.192-.416 5.472-1.248 1.312-.832 1.968-2 1.968-3.504 0-1.472-.672-2.656-2.016-3.552-1.344-.928-3.632-1.744-6.864-2.448-4.768-1.024-8.224-2.368-10.368-4.032-2.144-1.696-3.216-3.872-3.216-6.528 0-1.728.544-3.264 1.632-4.608 1.12-1.344 2.672-2.384 4.656-3.12 2.016-.736 4.336-1.104 6.96-1.104 2.944 0 5.584.496 7.92 1.488 2.368.992 4.112 2.368 5.232 4.128.32.512.48 1.008.48 1.488 0 .704-.352 1.296-1.056 1.776-.416.256-.832.384-1.248.384-.384 0-.768-.096-1.152-.288a2.834 2.834 0 01-.96-.768c-.928-1.216-2.208-2.144-3.84-2.784-1.6-.672-3.392-1.008-5.376-1.008-2.496 0-4.416.384-5.76 1.152-1.312.736-1.968 1.824-1.968 3.264 0 1.344.64 2.448 1.92 3.312 1.28.832 3.536 1.616 6.768 2.352 4.896 1.152 8.416 2.576 10.56 4.272 2.144 1.696 3.216 3.904 3.216 6.624 0 1.824-.544 3.44-1.632 4.848-1.056 1.376-2.56 2.448-4.512 3.216-1.952.736-4.224 1.104-6.816 1.104z"
                fill={strokeColor}
            />
        </svg>
    );
}


export {
    ImageIcon,
    HomeComponent,
    ProductIcon,
    EventIcon,
    NewsIcon,
    ProfileIcon,
    ExitIcon,
    EyeIcon,
    EditIcon,
    DeleteIcon,
    AddIcon,
    CategoryIcon,
    LinkIcon,
    TaxIcon,
    LocationIcon,
    MediaIcon,
    ProducerIcon,
    PersonIcon,
    FileIcon,
    QrIcon,
    SmartVenuesLogo
};
